  <template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' :model='queryForm' ref='form' label-width='80px' :inline='true' size='small'
                 class='query-form' @submit.native.prevent>
            <el-form-item label='店铺名称'>
                <el-input v-model='queryForm.shopName'></el-input>
            </el-form-item>
            <el-form-item label='联系人'>
                <el-input v-model='queryForm.contactPerson'></el-input>
            </el-form-item>
            <el-form-item label='联系电话'>
                <el-input v-model='queryForm.contactPhone'></el-input>
            </el-form-item>
            <el-form-item label='店铺管理'>
                <el-input v-model='queryForm.userId'></el-input>
            </el-form-item>
            <el-form-item label='核审状态'>
                <el-input v-model='queryForm.status'></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getMallShopList'>查询</el-button>
                <el-button size='small' icon='el-icon-refresh' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <!--        <el-button-->
                    <!--          type="primary"-->
                    <!--          size="small"-->
                    <!--          icon="el-icon-plus"-->
                    <!--          @click="addMallShop"-->
                    <!--        >新建</el-button>-->
                    <el-button
                        type='warning'
                        plain
                        size='small'
                        icon='el-icon-edit'
                        :disabled='multipleSelection.length != 1'
                        @click='editMallShop(null)'
                    >修改
                    </el-button>
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        icon='el-icon-delete'
                        :disabled='multipleSelection.length <= 0'
                        @click='deleteMallShop(null)'
                    >删除
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               class='upload-demo'
                               action='#'
                               :http-request='upload'
                               :show-file-list='true'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title='搜索'
                        class='icon-box'
                        @click='search'
                    >
                      <Icon color='#606266'>
                        <Search />
                      </Icon>
                    </span>
                    <!--        <span-->
                    <!--          title="下载模板"-->
                    <!--          class="icon-box"-->
                    <!--          @click="importTemplate"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDown />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          class="icon-box"-->
                    <!--          title="导入数据"-->
                    <!--          @click="isImport"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowExportUp24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="导出数据"-->
                    <!--          class="icon-box"-->
                    <!--          @click="exportMallShopList"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDownload24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <span
                        class='icon-box'
                        @click='refreshMallShopList'
                    >
                      <Icon color='#606266'>
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data='mallShopList'
                row-key='id'
                height='100%'
                border
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change='handleSelectionChange'
                size='small'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column align="center" prop="shopLogo" label="店铺信息" min-width="300" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if='scope.row.shopLogo' style="display: flex;justify-content: center;align-items: center;">
                        <el-image @click='updateSrcList(scope.row.shopLogo)' style="width: 60px; height: 60px"
                            :src="scope.row.shopLogo" :preview-src-list="srcList"> </el-image>
                            <div style="flex:auto;text-align: center;margin-left: 4px;">
                            <div>{{ scope.row.shopName }}</div>
                            <!-- <div :style="{'fontSize':'12px',color:scope.row.openStatus == 1 ? 'green':'red'}">({{ scope.row.openStatus == 1 ? '正常营业' : '暂停营业' }})</div> -->
                            <div>{{ scope.row.openHours }}</div>
                            </div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='shopName'
                    label='店铺名称'
                    width='180'
                ></el-table-column>
                <el-table-column
                    align='center'
                    prop='shopLogo'
                    label='店铺LOGO'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div v-if='scope.row.shopLogo'>
                            <el-image
                                @click='updateSrcList(scope.row.shopLogo)'
                                style='width: 80px; height: 80px'
                                :src='scope.row.shopLogo'
                                :preview-src-list='srcList'
                            ></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column
                    align='center'
                    prop='shopBanner'
                    label='店铺BANNER'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div v-if='scope.row.shopBanner'>
                            <el-image
                                @click='updateSrcList(scope.row.shopBanner)'
                                style='width: 80px; height: 80px'
                                :src='scope.row.shopBanner'
                                :preview-src-list='srcList'
                            ></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column> -->
                <el-table-column :show-overflow-tooltip="true" align="center" prop="shopAddress" label="地址" width="300">
                    <template slot-scope="scope">
                        <div v-if='scope.row.shopAddress'>
                        <div style="text-align: left;">区域:{{ scope.row.province.areaName }}{{ scope.row.city.areaName }}{{ scope.row.area.areaName }}</div>
                        <div style="text-align: left;overflow:hidden;text-overflow: ellipsis;">详细地址:{{ scope.row.shopAddress }}</div>
                        </div>

                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='provinceId'
                    label='所属省份'
                    width='180'
                >
                    <template slot-scope='scope' v-if='scope.row.province'>
                        <div>{{ scope.row.province.areaName }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='cityId'
                    label='所属城市'
                    width='180'
                >
                    <template slot-scope='scope' v-if='scope.row.city'>
                        <div>{{ scope.row.city.areaName }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='areaId'
                    label='所属区县'
                    width='180'
                >
                    <template slot-scope='scope' v-if='scope.row.area'>
                        <div>{{ scope.row.area.areaName }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='shopAddress'
                    label='详细地址'
                    width='180'
                ></el-table-column> -->
                <!-- <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='shopPosition'
                    label='店铺位定'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='openHours'
                    label='营业时间'
                    width='180'
                ></el-table-column> -->
                <el-table-column :show-overflow-tooltip="true" align="center" prop="contactPerson" label="联系人" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.contactPerson">
                            <div style="text-align: left">联系姓名:{{ scope.row.contactPerson }}</div>
                            <div style="text-align: left">联系电话:{{ scope.row.contactPhone }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='contactPerson'
                    label='店铺联系人'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='contactPhone'
                    label='联系人电话'
                    width='180'
                ></el-table-column> -->
                <!--      <el-table-column-->
                <!--        :show-overflow-tooltip="true"-->
                <!--        align="center"-->
                <!--        prop="remarks"-->
                <!--        label="备注"-->
                <!--        width="180"-->
                <!--      > </el-table-column>-->
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='paymentCode'
                    label='店铺收款码'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div v-if='scope.row.paymentCode'>
                            <el-image
                                @click='updateSrcList(scope.row.paymentCode)'
                                style='width: 80px; height: 80px'
                                :src='scope.row.paymentCode'
                                :preview-src-list='srcList'
                            ></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  align="left"
                  label="店铺管理"
                  width="180"
                >
                <template slot-scope="scope" v-if='scope.row.user'>
                    <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                	<div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                    <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                    <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
                </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='applyName'
                    label='申请人姓名'
                    width='180'
                >
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='idcardFront'
                    label='身份证正面'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div v-if='scope.row.idcardFront'>
                            <el-image
                                @click='updateSrcList(scope.row.idcardFront)'
                                style='width: 80px; height: 80px'
                                :src='scope.row.idcardFront'
                                :preview-src-list='srcList'
                            ></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='idcardBack'
                    label='身份证反面'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div v-if='scope.row.idcardBack'>
                            <el-image
                                @click='updateSrcList(scope.row.idcardBack)'
                                style='width: 80px; height: 80px'
                                :src='scope.row.idcardBack'
                                :preview-src-list='srcList'
                            ></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='applyCompany'
                    label='申请公司名称'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='companyLicense'
                    label='公司营业执照'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div v-if='scope.row.companyLicense'>
                            <el-image
                                @click='updateSrcList(scope.row.companyLicense)'
                                style='width: 80px; height: 80px'
                                :src='scope.row.companyLicense'
                                :preview-src-list='srcList'
                            ></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='status'
                    label='核审状态'
                    width='180'
                >
                    <template slot-scope="scope">
                        <div>{{ computeAuditStatus(scope.row.status) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='createTime'
                    label='创建时间'
                    width='180'
                ></el-table-column>
                <el-table-column
                    fixed='right'
                    align='center'
                    label='操作'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <div @click='mallAudit(scop.row)' v-if='scop.row.status == 1'>
                                <el-button type='primary' size='small'>审核</el-button>
                            </div>
                            <div @click='checkMallShop(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看</span>
                            </div>
                            <div @click='editMallShop(scop.row.id)'>
                                <Icon size='16'>
                                    <Edit24Regular />
                                </Icon>
                                <span class='operation-label'>修改</span>
                            </div>
                            <div @click='deleteMallShop(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title='mallShopStates[mallShopState]'
                :visible.sync='showDialog'
                width='60%'
                @close='closeDialog'
            >
                <div>
                    <el-form
                        :model='mallShop'
                        ref='mallShopForm'
                        :rules='rules'
                        label-width='120px'
                        :inline='true'
                        size='small'
                    >
                        <el-form-item
                            label='店铺名称'
                            prop='shopName'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mallShop.shopName'
                                :disabled="mallShopState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='详细地址'
                            prop='shopAddress'
                        >
                            <location
                                style='width: 200px;'
                                :areaTreeDate="areaTreeDate"
                                :longitude="mallShop.shopPosition.split(',')[0]"
                                :latitude="mallShop.shopPosition.split(',')[1]"
                                :provinceId="mallShop.provinceId"
                                :cityId="mallShop.cityId"
                                :areaId="mallShop.areaId"
                                :address="mallShop.shopAddress"
                                :disabled="mallShopState == 'check'"
                                @getLocation="getLocation"
                            ></location>
                        </el-form-item>
                        <el-form-item
                            label='所属省份'
                            prop='provinceId'
                        >
                            <el-select
                                placeholder='请选择省'
                                @change="clearSubitem('province')"
                                clearable
                                style='width: 200px'
                                size='small'
                                v-model='mallShop.provinceId'
                                :disabled="mallShopState == 'check'"
                            >
                                <el-option
                                    v-for='(item,index) in provinceArry'
                                    :key='index'
                                    :label='item.areaName'
                                    :value='item.id'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='所属城市'
                            prop='cityId'
                        >
                            <el-select
                                placeholder='请选择市'
                                @change="clearSubitem('city')"
                                clearable
                                style='width: 200px'
                                size='small'
                                v-model='mallShop.cityId'
                                :disabled="mallShopState == 'check'"
                            >
                                <el-option
                                    v-for='(item,index) in cityArry'
                                    :key='index'
                                    :label='item.areaName'
                                    :value='item.id'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='所属区县'
                            prop='areaId'
                        >
                            <el-select
                                placeholder='请选择区'
                                clearable
                                style='width: 200px'
                                size='small'
                                v-model='mallShop.areaId'
                                :disabled="mallShopState == 'check'"
                            >
                                <el-option
                                    v-for='(item,index) in areaArry'
                                    :key='index'
                                    :label='item.areaName'
                                    :value='item.id'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!--                        <el-form-item-->
                        <!--                            label='详细地址'-->
                        <!--                            prop='shopAddress'-->
                        <!--                        >-->
                        <!--                            <el-input-->
                        <!--                                size='small'-->
                        <!--                                v-model='mallShop.shopAddress'-->
                        <!--                                :disabled="mallShopState == 'check'"-->
                        <!--                            ></el-input>-->
                        <!--                        </el-form-item>-->
                        <el-form-item
                            label='店铺位定'
                            prop='shopPosition'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mallShop.shopPosition'
                                :disabled="mallShopState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='营业时间'
                            prop='openHours'
                        >
                            <el-time-picker
                                is-range
                                style='width: 200px;'
                                v-model='mallShop.openHours'
                                :disabled="mallShopState == 'check'"
                                range-separator='至'
                                format='HH:mm:ss'
                                value-format='HH:mm:ss'
                                start-placeholder='开始时间'
                                end-placeholder='结束时间'
                                placeholder='选择时间范围'>
                            </el-time-picker>
                        </el-form-item>
                        <el-form-item
                            label='联系人姓名'
                            prop='contactPerson'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mallShop.contactPerson'
                                :disabled="mallShopState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='联系人电话'
                            prop='contactPhone'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mallShop.contactPhone'
                                :disabled="mallShopState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <!--el-form-item
                            label='积分抵扣'
                            prop='contactPhone'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mallShop.scoreDiscount'
                                :disabled="mallShopState == 'check'"
                            ></el-input>
                        </el-form-item-->
                        <el-form-item
                            label='店铺管理'
                            prop='userId'
                        >
                            <GridSelect
                                style='width: 200px'
                                title='选择用户'
                                labelName='userName'
                                labelValue='id'
                                :value='mallShop.userId'
                                :limit='1'
                                size='small'
                                placeholder='请选择用户'
                                :disabled="mallShopState == 'check'"
                                @getValue='getValueUserId'
                                :columns="USER_code"
                                :searchs="USER_search"
                                dataListUrl='/mpp/user/findList'
                                entityBeanName='mppUser'
                                queryEntityUrl='/mpp/user/get'
                            >
                            </GridSelect>
                        </el-form-item>
<!--                        <el-form-item-->
<!--                            label="可以供货"-->
<!--                            prop="canSupply"-->
<!--                        >-->
<!--                            <el-select-->
<!--                                placeholder="请选择是否可以供货"-->
<!--                                clearable-->
<!--                                style="width: 200px"-->
<!--                                size="small"-->
<!--                                :disabled="mallShopState == 'check'"-->
<!--                                v-model="mallShop.canSupply"-->
<!--                            >-->
<!--                                <el-option-->
<!--                                    v-for='(item,index) in yesNoEnumList'-->
<!--                                    :key='index'-->
<!--                                    :label="item.value"-->
<!--                                    :value="item.key"-->
<!--                                >-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label="销售模式"
                            prop="saleMode"
                        >
                            <el-select
                                placeholder="请选择销售模式"
                                clearable
                                style="width: 200px"
                                size="small"
                                v-model="mallShop.saleMode"
                                :disabled="mallShopState == 'check'"
                            >
                                <el-option
                                    v-for='(item,index) in saleModeEnumList'
                                    :key='index'
                                    :label="item.value"
                                    :value="item.key"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
<!--                        <el-form-item-->
<!--                            label="批发价格"-->
<!--                            prop="wholesalePrice"-->
<!--                            v-if="mallShop.saleMode == 3"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px;"-->
<!--                                v-model="mallShop.wholesalePrice"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="起批数量"-->
<!--                            prop="buyMinLimit"-->
<!--                            v-if="mallShop.saleMode == 3"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px;"-->
<!--                                v-model="mallShop.buyMinLimit"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label='申请人姓名'
                            prop=' applyName'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mallShop.applyName'
                                :disabled="mallShopState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='申请公司名称'
                            prop='applyCompany'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mallShop.applyCompany'
                                :disabled="mallShopState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='店铺LOGO'
                            prop='shopLogo'
                        >
                            <el-upload
                                style='width: 200px'
                                class='avatar-uploader'
                                action=''
                                :show-file-list='false'
                                :http-request='uploadShopLogo'
                                :disabled="mallShopState == 'check'"
                            >
                                <img v-if='mallShop.shopLogo' :src='mallShop.shopLogo' class='avatar' size='small' />
                                <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label='店铺BANNER'
                            prop='shopBanner'
                        >
                            <el-upload
                                style='width: 200px'
                                class='avatar-uploader'
                                action=''
                                :show-file-list='false'
                                :http-request='uploadBanner'
                                :disabled="mallShopState == 'check'"
                            >
                                <img v-if='mallShop.shopBanner' :src='mallShop.shopBanner' class='avatar' size='small' />
                                <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label='身份证正面'
                            prop='idcardFront'
                        >
                            <el-upload
                                style='width: 200px'
                                class='avatar-uploader'
                                action=''
                                :show-file-list='false'
                                :http-request='uploadIdcardFront'
                                :disabled="mallShopState == 'check'"
                            >
                                <img v-if='mallShop.idcardFront' :src='mallShop.idcardFront' class='avatar' size='small' />
                                <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label='身份证反面'
                            prop='idcardBack'
                        >
                            <el-upload
                                style='width: 200px'
                                class='avatar-uploader'
                                action=''
                                :show-file-list='false'
                                :http-request='uploadIdcardBack'
                                :disabled="mallShopState == 'check'"
                            >
                                <img v-if='mallShop.idcardBack' :src='mallShop.idcardBack' class='avatar' size='small' />
                                <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label='公司营业执照'
                            prop='companyLicense'
                        >
                            <el-upload
                                style='width: 200px'
                                class='avatar-uploader'
                                action=''
                                :show-file-list='false'
                                :http-request='uploadCompanyLicense'
                                :disabled="mallShopState == 'check'"
                            >
                                <img v-if='mallShop.companyLicense' :src='mallShop.companyLicense' class='avatar' size='small' />
                                <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot='footer'
                    class='flex justify-end'
                >
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button
                        type='primary'
                        @click='submitForm'
                        v-if="mallShopState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>

            <!--审核功能-->
            <el-dialog title='店铺申请审核' :visible.sync='retreatDialogVisible' width='30%'
                       :before-close='handleCloseRetreat'>
                <el-form ref='retreatForm' :rules='retreatRules' size='small' :model='retreatForm' label-width='100px'>
                    <el-form-item label='申请说明：'>
                        <el-input style='width: 100%' type='textarea' v-model='applyRemarks'
                                  :disabled='true'></el-input>
                    </el-form-item>
                    <el-form-item label='是否同意：' prop='resource'>
                        <el-radio-group v-model='retreatForm.resource'>
                            <el-radio label='true'>同意</el-radio>
                            <el-radio label='false'>拒绝</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label='拒绝原因：' v-if="retreatForm.resource == 'false'" prop='desc'>
                        <el-input style='width: 100%' type='textarea' v-model='retreatForm.desc'></el-input>
                    </el-form-item>
                </el-form>
                <span slot='footer' class='dialog-footer'>
              <el-button @click='handleCloseRetreat'>取 消</el-button>
              <el-button type='primary' @click="retreatSuccess('retreatForm')">确 定</el-button>
          </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put,upload , deleteFun } from '@/utils/request.js';
import Location from '@/components/location/location.vue';
import GridSelect from '@/components/gridselect/index.vue';
import { UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelect,
        Location,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMallShopList();
                this.getMallShopList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMallShopList();
                this.getMallShopList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            auditStatus: [],
            areaTreeDate: [],
            yesNoEnumList: [],
            retreatDialogVisible: false,
            saleModeEnumList: [],
            queryForm: {
                shopName: '', //店铺名称
                shopLogo: '', //店铺logo
                shopBanner: '', //店铺banner
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                shopAddress: '', //详细地址
                shopPosition: '', //位定
                openHours: '', //营业时间
                contactPerson: '', //联系人
                contactPhone: '', //联系电话
                remarks: '', //备注
                paymentCode: '', //收款码
                userId: '', //店铺管理
                saleMode: '', //是否可以供货
                applyName: '', //申请人姓名
                idcardFront: '', //申请人身份证正面
                idcardBack: '', //申请人身份证反面
                applyCompany: '', //申请公司名称
                companyLicense: '', //公司营业执照
                status: '', //核审状态
                createTime: '', //创建时间
            },
            srcList: [''],//大图预览
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mallShopState: 'add',
            mallShopStates: {
                add: '新建店铺',
                check: '查看店铺',
                edit: '修改店铺'
            },

            multipleSelection: [],
            mallShopList: [],
            mallShop: {
                shopName: '', //店铺名称
                shopLogo: '', //店铺logo
                shopBanner: '', //店铺banner
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                shopAddress: '', //详细地址
                shopPosition: '', //位定
                openHours: '', //营业时间
                contactPerson: '', //联系人
                contactPhone: '', //联系电话
                scoreDiscount: '', //积分抵扣
                remarks: '', //备注
                paymentCode: '', //收款码
                userId: '', //店铺管理
                saleMode: 1, //是否可以供货
                applyName: '', //申请人姓名
                idcardFront: '', //申请人身份证正面
                idcardBack: '', //申请人身份证反面
                applyCompany: '', //申请公司名称
                companyLicense: '', //公司营业执照
                status: '', //核审状态
                createTime: '', //创建时间
                wholesalePrice: '',
                buyMinLimit: ''
            },
            btnLoading: false,

            rules: {
                shopName: [{ required: true, message: '店铺名称不能为空', trigger: 'blur' }],
                shopLogo: [{ required: true, message: '店铺logo不能为空', trigger: 'blur' }],
                shopBanner: [{ required: true, message: '店铺banner不能为空', trigger: 'blur' }],
                provinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
                cityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
                areaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
                shopAddress: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
                shopPosition: [{ required: true, message: '位定不能为空', trigger: 'blur' }],
                openHours: [{ required: true, message: '营业时间不能为空', trigger: 'blur' }],
                contactPerson: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
                contactPhone: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
                scoreDiscount: [{ required: true, message: '积分抵扣不能为空', trigger: 'blur' }],
                remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                paymentCode: [{ required: true, message: '收款码不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '店铺管理不能为空', trigger: 'blur' }],
                saleMode: [{ required: true, message: '销售模式不能为空', trigger: 'blur' }],
                applyName: [{ required: true, message: '申请人姓名不能为空', trigger: 'blur' }],
                idcardFront: [{ required: true, message: '申请人身份证正面不能为空', trigger: 'blur' }],
                idcardBack: [{ required: true, message: '申请人身份证反面不能为空', trigger: 'blur' }],
                applyCompany: [{ required: true, message: '申请公司名称不能为空', trigger: 'blur' }],
                companyLicense: [{ required: true, message: '公司营业执照不能为空', trigger: 'blur' }],
                status: [{ required: true, message: '核审状态不能为空', trigger: 'blur' }],
                createTime: [{ required: true, message: '创建时间不能为空', trigger: 'blur' }],
                wholesalePrice: [{ required: true, message: '批发价格不能为空', trigger: 'blur' }],
                buyMinLimit: [{ required: true, message: '起批数量不能为空', trigger: 'blur' }],
            },
            retreatRules: {
                resource: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
                desc: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }]
            },
            auditId: '',// 申请人的id
            applyRemarks: '',// 申请人的说明
            retreatForm: {
                resource: '',
                desc: ''
            }
        };
    },
    created() {
        this.getTreeData();
        this.getMallShopList();
        this.getAuditStatus();
        this.getYesNoEnum();
        this.getSaleModeEnumList()
    },
    computed: {
        provinceArry() {
            return this.areaTreeDate;
        },
        cityArry() {
            if (!this.provinceArry) {
                return [];
            } else {
                for (let i = 0; i < this.provinceArry.length; i++) {
                    if (this.provinceArry[i].id == this.mallShop.provinceId) {
                        return this.provinceArry[i].children;
                    } else if (this.mallShop.provinceId == '') {
                        return [];
                    }
                }
            }
        },
        areaArry() {
            if (!this.cityArry) {
                return [];
            } else {
                for (let i = 0; i < this.cityArry.length; i++) {
                    if (this.cityArry[i].id == this.mallShop.cityId) {
                        return this.cityArry[i].children;
                    }
                }
            }
        }
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        getSaleModeEnumList(){
            get('/mpp/utils/getEnum',{
                enumType: 'sale_mode',
            }).then((res)=>{
                if(res.success){
                    this.saleModeEnumList = res.enumList
                }
            })
        },
        resetMallShopList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mallShopList = [];
        },
        resetDialog() {
            this.mallShopState = 'add';
            this.showDialog = false;
            this.queryForm = {
                shopName: '', //店铺名称
                shopLogo: '', //店铺logo
                shopBanner: '', //店铺banner
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                shopAddress: '', //详细地址
                shopPosition: '', //位定
                openHours: '', //营业时间
                contactPerson: '', //联系人
                contactPhone: '', //联系电话
                remarks: '', //备注
                paymentCode: '', //收款码
                userId: '', //店铺管理
                saleMode: '', //是否可以供货
                applyName: '', //申请人姓名
                idcardFront: '', //申请人身份证正面
                idcardBack: '', //申请人身份证反面
                applyCompany: '', //申请公司名称
                companyLicense: '', //公司营业执照
                status: '', //核审状态
                createTime: '' //创建时间
            };
            this.getMallShopList();
        },
        closeDialog() {
            this.showDialog = false;
            this.mallShop = {
                shopName: '', //店铺名称
                shopLogo: '', //店铺logo
                shopBanner: '', //店铺banner
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                shopAddress: '', //详细地址
                shopPosition: '', //位定
                openHours: '', //营业时间
                contactPerson: '', //联系人
                contactPhone: '', //联系电话
                remarks: '', //备注
                paymentCode: '', //收款码
                userId: '', //店铺管理
                saleMode: 3, //是否可以供货
                applyName: '', //申请人姓名
                idcardFront: '', //申请人身份证正面
                idcardBack: '', //申请人身份证反面
                applyCompany: '', //申请公司名称
                companyLicense: '', //公司营业执照
                status: '', //核审状态
                createTime: '' //创建时间
            };
        },
        submitForm() {
            if (this.mallShopState == 'add') {
                this.$refs.mallShopForm.validate((valid) => {
                    if (valid) {
                        this.mallShop.openHours = this.mallShop.openHours.join('-');
                        console.log('submit');
                        post(`/restaurant/shop/add`, { ...this.mallShop }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMallShopList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.mallShopState == 'edit') {
                this.$refs.mallShopForm.validate((valid) => {
                    if (valid) {
                        this.mallShop.openHours = this.mallShop.openHours.join('-');

                        delete this.mallShop.province;
                        delete this.mallShop.city;
                        delete this.mallShop.area;
						delete this.mallShop.user;
                        console.log('submit');
                        post(`/restaurant/shop/edit`, { ...this.mallShop }).then((res) => {
                            if (res.success && res.code == 200) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMallShopList();
                                this.resetDialog();
                            } else {
                                this.mallShop.openHours = this.mallShop.openHours.split('-');
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addMallShop() {
            this.showDialog = true;
            this.mallShopState = 'add';
        },
        checkMallShop(mallShopId) {
            console.log(mallShopId);
            this.currentMallShopId = mallShopId;

            this.getMallShopById();
            this.showDialog = true;
            this.mallShopState = 'check';
        },
        editMallShop(mallShopId) {
            console.log('mallShop', mallShopId);
            if (mallShopId) {
                this.currentMallShopId = mallShopId;
                this.getMallShopById();
            } else {
                this.mallShop = { ...this.mallShop, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mallShopState = 'edit';
        },
        deleteMallShop(mallShopId) {
            let ids = '';
            if (mallShopId) {
                ids = mallShopId;
            } else {
                ids = this.multipleSelection.map((mallShop) => mallShop.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/restaurant/shop/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMallShopList();
                            this.getMallShopList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMallShopList() {
            this.resetMallShopList();
            this.getMallShopList();
        },
        getMallShopList(query = {}) {
            this.loading = true;
            get(`/restaurant/shop/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mallShopList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getMallShopById() {
            get(`/restaurant/shop/get`, { id: this.currentMallShopId }).then((res) => {
                if (res.success) {
                    this.mallShop = { ...this.mallShop, ...res.mallShop };
                    this.mallShop.openHours = this.mallShop.openHours.split('-');
                }
            });
        },
        /**
         * 导出信息
         */
        exportMallShopList() {
            //this.btnLoading = true;
            exprotExcel(`/restaurant/shop/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/restaurant/shop/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/restaurant/shop/importData`, formData);
            this.refreshMallShopList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMallShopList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMallShopList();
        },
        //上传logo
        uploadShopLogo(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.shopLogo = res.url;
                }
            });
        },

        //上传banner
        uploadBanner(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.shopBanner = res.url;
                    console.log('this.mallShop.shopBanner',this.mallShop.shopBanner)
                }
            });
        },

        //上传身份证正面
        uploadIdcardFront(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.idcardFront = res.url;
                }
            });
        },

        // 上传身份证反面
        uploadIdcardBack(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.idcardBack = res.url;
                }
            });
        },

        // 上传公司营业执照
        uploadCompanyLicense(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mallShop.companyLicense = res.url;
                }
            });
        },

        // 获取yes_no枚举
        getYesNoEnum(){
            get('/mpp/utils/getEnum',{
                enumType: 'yes_no',
            }).then((res)=>{
                if(res.success){
                    this.yesNoEnumList = res.enumList
                }
            })
        },

        //
        mallAudit(item) {
            console.log('applyRemarks',item)
            this.retreatDialogVisible = true;
            this.auditId = item.id;
            this.applyRemarks = item.remarks;
            this.retreatDialogVisible = true;
        },

        // 审核取消按钮
        handleCloseRetreat() {
            this.retreatDialogVisible = false;
            this.auditId = '';//关闭后清除点击的id
            this.applyRemarks = ''; //关闭后清除申请人的说明
            this.retreatForm.resource = '';//关闭后把选择的按钮置空
            this.retreatForm.desc = '';//关闭后把拒绝利用清空
        },

        //审核确认按钮
        retreatSuccess(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //处理选择同意&拒绝
                    let status = 1;
                    this.retreatForm.resource == 'true' ? status = 2 : status = 3;
                    this.retreatDialogVisible = false;
                    get(`/restaurant/shop/auditShop`, {
                        id: this.auditId,
                        status: status,
                        refuseReason: this.retreatForm.desc
                    }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.getMallShopList();
                        }
                    });
                }
            });
        },
        getTreeData() {
            get('/mpp/area/treeData').then((res) => {
                console.log(res.treeData[0].children)
                if (res.success) {
                    this.areaTreeDate = res.treeData[0].children;
                }
            });
        },
        updateSrcList(src) {
            this.srcList[0] = src;
        },
        getLocation(location){
            this.mallShop.shopPosition = `${location.lng},${location.lat}`
            this.mallShop.shopAddress = location.address
            this.mallShop.provinceId = location.province
            this.mallShop.cityId = location.city
            this.mallShop.areaId = location.area
        },
        clearSubitem(id) {
            if (id == 'province') {
                this.mallShop.cityId = '';
                this.mallShop.areaId = '';
            } else if (id == 'city') {
                this.mallShop.areaId = '';
            }
        },
        getValueUserId(value) {
            this.mallShop.userId = value;
        },
        // 获取AuditStatusEnum枚举
        getAuditStatus() {
            get('/mpp/utils/getEnum', { enumType: 'audit_status' }).then((res) => {
                this.auditStatus = res.enumList;
            });
        },

        // 计算AuditStatus
        computeAuditStatus(type){
            for (let i = 0; i < this.auditStatus.length; i++) {
                if(this.auditStatus[i].key == type){
                    return this.auditStatus[i].value
                }
            }
        },
    }
};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}

::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}

.avatarWide {
    width: 200px;
    height: 120px;
}
</style>
